import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-massroster-preview',
  template: `
    <div class="modal-header">

      <h4 class="modal-title">{{title}}</h4>

      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">

        <span aria-hidden="true">&times;</span>

      </button>

    </div>

    <div class="modal-body">

      {{text}}

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="activeModal.close('Publish click')">OK</button>
    </div>
  `,
  styles: []
})
export class MassrosterPreviewComponent implements OnInit {

  @Input() text: string;

  @Input() title: string;

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/articles/massroster/massroster-preview/massroster-preview.component.ts